
export default function Tokenomics() {
  const tokenData = [
    { label: 'Public Sale', percentage: 40, color: 'from-cyan-500 to-blue-600', amount: '400M PEP' },
    { label: 'Team & Advisors', percentage: 20, color: 'from-purple-500 to-pink-600', amount: '200M PEP' },
    { label: 'Development', percentage: 15, color: 'from-green-500 to-emerald-600', amount: '150M PEP' },
    { label: 'Marketing', percentage: 10, color: 'from-orange-500 to-red-600', amount: '100M PEP' },
    { label: 'Liquidity', percentage: 10, color: 'from-indigo-500 to-purple-600', amount: '100M PEP' },
    { label: 'Reserve', percentage: 5, color: 'from-gray-500 to-slate-600', amount: '50M PEP' }
  ];

  const features = [
    {
      icon: 'ri-coins-line',
      title: 'Total Supply',
      value: '1,000,000,000 PEP',
      description: 'Fixed supply with transparent distribution across all stakeholders'
    },
    {
      icon: 'ri-fire-line',
      title: 'Burn Rate',
      value: '2% Monthly',
      description: 'Systematic token burns to increase scarcity and value'
    },
    {
      icon: 'ri-gift-line',
      title: 'Staking Rewards',
      value: 'Up to 25% APY',
      description: 'Earn premium rewards by staking your PEP tokens'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Security',
      value: 'Audited Smart Contract',
      description: 'Fully audited and secure token contract implementation'
    }
  ];

  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Token Economics & Distribution Model
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Transparent allocation structure with vesting schedules and utility-based token design. Subject to market volatility and regulatory changes.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Distribution Chart */}
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-6">Token Allocation Breakdown</h3>
            <div className="space-y-4">
              {[
                { label: 'Platform Development & Operations', value: '30%', color: 'bg-blue-500', description: 'Infrastructure, security audits, technical upgrades' },
                { label: 'Community Incentives & Staking', value: '25%', color: 'bg-purple-500', description: 'Rewards pool with time-locked vesting' },
                { label: 'Liquidity Provision', value: '20%', color: 'bg-emerald-500', description: 'Market making and exchange liquidity' },
                { label: 'Team & Advisors (4-year vest)', value: '15%', color: 'bg-orange-500', description: 'Locked with quarterly release schedule' },
                { label: 'Reserve Fund', value: '10%', color: 'bg-pink-500', description: 'Emergency fund and future development' }
              ].map((item, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-white font-medium">{item.label}</span>
                    <span className="text-white font-bold">{item.value}</span>
                  </div>
                  <div className="w-full bg-white/10 rounded-full h-3 overflow-hidden">
                    <div 
                      className={`${item.color} h-full rounded-full transition-all duration-1000`}
                      style={{ width: item.value }}
                    ></div>
                  </div>
                  <p className="text-white/60 text-sm">{item.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Utility & Governance */}
          <div className="space-y-6">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                  <i className="ri-coins-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-white">Token Utility Functions</h3>
              </div>
              <ul className="space-y-3 text-white/80">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-400 mt-1"></i>
                  <span>Transaction fee payment and gas optimization</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-400 mt-1"></i>
                  <span>Staking for network validation (subject to lock-up periods)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-400 mt-1"></i>
                  <span>Governance voting rights on protocol upgrades</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-400 mt-1"></i>
                  <span>Access to premium platform features and analytics</span>
                </li>
              </ul>
            </div>

            <div className="bg-amber-500/20 border border-amber-500/50 rounded-xl p-6 backdrop-blur-sm">
              <div className="flex items-start gap-3">
                <i className="ri-alert-line text-amber-400 text-xl mt-0.5"></i>
                <div>
                  <p className="text-white font-semibold mb-2">Token Value Disclaimer</p>
                  <p className="text-white/90 text-sm leading-relaxed">
                    Token value is highly volatile and speculative. No guaranteed returns or price stability. Regulatory changes may impact token utility and transferability. Liquidity not guaranteed.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
